module.exports = __webpack_public_path__ + "img/login-bg.cba144f1.jpg";